import styled, { css } from 'styled-components';

import { Col as BaseColumn } from '@/components/Col';
import { Row } from '@/components/Row';
import { theme } from '@/theme';

export const Wrapper = styled(Row)`
  ${({ theme }) => css`
    ${theme.media.md.down} {
      gap: ${theme.spacing(2)};
    }
  `}
`;

export const Col = styled(BaseColumn)`
  height: 100%;
  position: relative;

  ${({ theme }) => css`
    padding: ${theme.spacing(1, 1, 0, 1)};
    ${theme.media.md.down} {
      padding: ${theme.spacing(1, 1, 0, 1)};
    }
  `}
  ${theme.media.md.up} {
    &[data-test-id='BaseCardTypeContent'][type='Icon'],
    & [data-test-id='BaseCardTypeContent'][type='Icon'] {
      height: 100%;
      justify-content: flex-start;
    }
  }
`;
